import { render, staticRenderFns } from "./ButtonAccreditation.vue?vue&type=template&id=79052042&scoped=true"
import script from "./ButtonAccreditation.vue?vue&type=script&lang=js"
export * from "./ButtonAccreditation.vue?vue&type=script&lang=js"
import style0 from "./ButtonAccreditation.vue?vue&type=style&index=0&id=79052042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79052042",
  null
  
)

export default component.exports